export const REVIEW_FORM_CARE_MODAL = 'go_help_center_review_form'

export const CARE_MODAL_NEGATIVE_REVIEW_MAX_RATE = 3
